import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import ChatLayout from '../../components/organisms/layouts/Chat';
import {EventHandler, Message, MessageResponse} from 'stream-chat';
import {RootState} from '../../redux/reducers';
import ListMessages from '../../components/organisms/lists/Messages';
import ChatForm from '../../components/organisms/forms/Chat';

const ChatRoom = () => {
  const {
    currentChannel,
    currentWatchChannel = {messages: []},
    id,
  } = useSelector((state: RootState) => ({
    ...state.channel,
    ...state.user,
  }));
  const [reply, setReply] = useState<any>();
  const [messages, setMessages] = useState<(MessageResponse | Message)[]>([]);
  const [isTyping, setIsTyping] = useState<string>();
  const [messagesEnd, setMessagesEnd] = useState<HTMLDivElement | null>();
  const chatName = React.useMemo(
    () =>
      currentWatchChannel
        ? //@ts-ignore
          currentWatchChannel.channel.name ||
          //@ts-ignore
          currentWatchChannel.members.find(
            (item: {user: {id: any}}) => item.user.id !== id,
          )?.user.name ||
          ''
        : '',
    [currentWatchChannel],
  );

  const eventStartTyping = (event: any) => {
    if (event.user.id !== id) setIsTyping(event.user.name);
  };

  const eventStopTyping = (event: any) => {
    if (event.user.id !== id) setIsTyping(undefined);
  };

  const handleEvent: EventHandler = event => {
    // @ts-ignore
    setMessages(prevMessages => [...prevMessages, event.message]);
    void currentChannel?.markRead();
  };

  useEffect(() => {
    setMessages([...currentWatchChannel?.messages]);

    currentChannel && currentChannel?.markRead();
    currentChannel?.on('typing.start', eventStartTyping);
    currentChannel?.on('typing.stop', eventStopTyping);
    currentChannel?.on('message.new', handleEvent);

    return () => {
      currentChannel && currentChannel?.markRead();
      currentChannel?.on('typing.start', eventStartTyping);
      currentChannel?.on('typing.stop', eventStopTyping);
      currentChannel?.on('message.new', handleEvent);
    };
  }, []);

  useEffect(() => {
    if (messagesEnd) {
      messagesEnd.scrollIntoView({behavior: 'smooth'});
    }
  }, [messagesEnd, messages]);

  return (
    <>
      <ChatLayout chatName={chatName}>
        <ListMessages messages={messages} />
        <ChatForm reply={reply} setReply={setReply} />
        <div ref={el => setMessagesEnd(el)}></div>
      </ChatLayout>
    </>
  );
};

export default ChatRoom;
